"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSpecificationError = exports.GET_SPEC_ERROR_CODES = void 0;
var funcError_1 = __importDefault(require("../funcError"));
exports.GET_SPEC_ERROR_CODES = {
    TYPE: 'TYPE',
};
var GetSpecificationError = /** @class */ (function (_super) {
    __extends(GetSpecificationError, _super);
    function GetSpecificationError() {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        var _this = _super.apply(this, params) || this;
        _this.name = 'GetSpecificationError';
        return _this;
    }
    return GetSpecificationError;
}(funcError_1.default));
exports.GetSpecificationError = GetSpecificationError;
/**
 * Получение спецификаций
 *
 * @param {object} specification поле specification из объекта автомобиль
 * @param {string} groupName
 * @param {string} specificationName
 * @param {string | string[]} fieldName
 */
function getSpecification(specification, groupName, specificationName, fieldName) {
    if (fieldName === void 0) { fieldName = 'value'; }
    if (!specification)
        return undefined;
    var group = specification.find(function (_a) {
        var id = _a.id;
        return id === groupName;
    });
    if (!group) {
        return undefined;
    }
    var groupItems = group.items;
    var option = groupItems.find(function (_a) {
        var id = _a.id;
        return id === specificationName;
    });
    if (!option) {
        return undefined;
    }
    var optionFields;
    var typeError = new GetSpecificationError(exports.GET_SPEC_ERROR_CODES.TYPE, "\"fieldName\" type error. It can be string or array of string, but got \"" + typeof fieldName + "\"");
    switch (typeof fieldName) {
        case 'string':
            optionFields = option[fieldName];
            break;
        case 'object':
            if (!Array.isArray(fieldName))
                throw typeError;
            optionFields = fieldName.map(function (name) { return option[name]; });
            break;
        default:
            throw typeError;
    }
    return optionFields;
}
exports.default = getSpecification;
